import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import MessageHeader from '@/modules/Chat/components/MessageHeader.vue';
import ActivityMessage from '@/modules/Chat/components/ActivityMessage.vue';
import { UserRepository } from '@/repositories/UserRepository';
import PlainMessageComponent from '@/shared/components/PlainMessageComponent.vue';
import { getActionsForType } from '@/modules/Chat/helpers/ChatHelper';
import { ChatRenderedMessage } from '@/modules/Chat/interfaces/ChatRenderedMessage';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageItem',
  props: {
    message: {
        type: Object as PropType<ChatRenderedMessage>,
        required: true,
    },
    selectedProjectId: {
        type: String as PropType<string | null>,
        default: null,
    },
    shouldShowActions: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {

const props = __props;



const currentUser = computed(() => UserRepository.getCurrentUser());

const isMadeByUserSameAsCurrentUser = computed(() => {
    if (currentUser.value == null || props.message.madeByUser == null) {
        return false;
    }

    return currentUser.value.id === props.message.madeByUser.id;
});

function getActionsForKebab(type: string) {
    if (props.selectedProjectId == null || !props.shouldShowActions) {
        return [];
    }

    return getActionsForType({
        type,
        projectId: props.selectedProjectId,
        nextStepId: props.message.nextStep == null ? null : props.message.nextStep.id,
        plainMessageId: props.message.content == null ? null : props.message.content.id,
        messageId: props.message.id,
        isMadeByUserSameAsCurrentUser: isMadeByUserSameAsCurrentUser.value,
    });
}

return { __sfc: true,props, currentUser, isMadeByUserSameAsCurrentUser, getActionsForKebab, MessageHeader, ActivityMessage, PlainMessageComponent }
}

})